import * as React from 'react'
function SvgChevronUp(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M28.8 26.867l-8.8-8.8-8.8 8.8a2.64 2.64 0 01-3.733-3.734l9.705-9.705a4 4 0 015.656 0l9.705 9.705a2.64 2.64 0 11-3.733 3.734z"
				fill="currentColor"
				fillRule="evenodd"
			/>
		</svg>
	)
}
export default SvgChevronUp
